import { render, staticRenderFns } from "./CampusRecruit.vue?vue&type=template&id=48f82d93&scoped=true&"
import script from "./CampusRecruit.vue?vue&type=script&lang=js&"
export * from "./CampusRecruit.vue?vue&type=script&lang=js&"
import style0 from "./CampusRecruit.vue?vue&type=style&index=0&id=48f82d93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f82d93",
  null
  
)

export default component.exports